import React, { useState } from 'react';
import { FiBookOpen, FiChevronDown, FiGrid, FiHelpCircle, FiSliders } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqItems = [
  {
    q: 'Ce diferențiază acest generator de numere loto 6/49 de altele?',
    a: 'Utilizează generare criptografică fără bias (Web Crypto API) și filtrează loturi de 15 variante loto 6 din 49 prin 5 metrici: paritate, sumă, interval, distribuție pe zeci și perechi consecutive.'
  },
  {
    q: 'Care este cea mai bună schemă loto 6 49?',
    a: 'Nu există o schemă magică de câștig, dar cele mai utilizate matematic sunt schemele reduse oficiale (ex. schema redusă 12 numere cod 57 și sistemele cod 58), care optimizează acoperirea combinațiilor cu un cost redus per bilet.'
  },
  {
    q: 'Cum funcționează scheme reduse loto 6/49 cod 57 și cod 58?',
    a: 'Codul 57 permite combinarea a 12 numere alese în doar 6 variante simple, asigurând condiții de câștig de categoria a II-a sau a III-a dacă numerele extrase se regăsesc în cele 12. Codul 58 reprezintă o schemă redusă mai amplă pentru jucătorii care vor mai multe numere în joc.'
  },
  {
    q: 'Pot genera numere norocoase la loto pentru extragerea de azi?',
    a: 'Da, poți rula oricând generatorul pentru extragerea de azi (joi sau duminică). Recomandăm să generezi un lot de 15 variante și să compari scorul de distribuție pentru a alege variante bine echilibrate.'
  }
];

function SeoContentSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="seo-content" aria-label="Ghid Loto 6/49 și Scheme Reduse">
      <div className="seo-intro-grid">
        <article className="seo-card">
          <div className="seo-card__title">
            <SafeIcon icon={FiSliders} />
            <h3>GENERATOR NUMERE LOTO 6/49 & SIMULATOR STATISTIC</h3>
          </div>
          <p>
            Dacă ești în căutarea unui <strong>generator loto</strong> sau a unui <strong>simulator loto 6/49</strong> precis, sistemul nostru generează <strong>variante loto 6 din 49</strong> bazate pe selecție uniformă securizată. Fiecare set de numere este trecut printr-un algoritm care analizează echilibrul par/impar, dispersia sumei și densitatea numerelor.
          </p>
        </article>

        <article className="seo-card">
          <div className="seo-card__title">
            <SafeIcon icon={FiGrid} />
            <h3>SCHEME REDUSE LOTO 6/49 (COD 57 & COD 58)</h3>
          </div>
          <p>
            Mulți jucători caută <em>cea mai bună schemă loto 6 49</em>. Sistemele cunoscute precum <strong>schema redusă 12 numere cod 57</strong> sau <strong>scheme reduse loto 6 49 cod 58</strong> oferă o organizare structurală eficientă pentru biletele jucate la Loteria Română, combinând grupuri de numere în mai puține variante simple.
          </p>
        </article>
      </div>

      <div className="seo-schemes-table-wrap">
        <div className="seo-card__title seo-card__title--padded">
          <SafeIcon icon={FiBookOpen} />
          <h3>GHID SCHEME REDUSE 6/49 PENTRU EXTRAGERI</h3>
        </div>
        <table className="seo-table">
          <thead>
            <tr>
              <th>COD SCHEMĂ</th>
              <th>NUMERE JUCATE</th>
              <th>VARIANTE SIMPLE</th>
              <th>UTILITATE STATISTICĂ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Cod 57</strong></td>
              <td>12 numere</td>
              <td>6 variante</td>
              <td>Garantează minim 4 numere dacă 5 din cele 12 sunt extrase.</td>
            </tr>
            <tr>
              <td><strong>Cod 58</strong></td>
              <td>10 numere</td>
              <td>15 variante</td>
              <td>Acoperire superioară pentru combinații compacte pe bilet.</td>
            </tr>
            <tr>
              <td><strong>Simulare Lot (15)</strong></td>
              <td>6 numere / variantă</td>
              <td>15 variante independente</td>
              <td>Sortare după scorul algoritmic de dispersie și paritate.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="seo-faq">
        <div className="seo-card__title seo-card__title--padded">
          <SafeIcon icon={FiHelpCircle} />
          <h3>ÎNTREBĂRI FRECVENTE (FAQ LOTO 6/49)</h3>
        </div>
        <div className="faq-list">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div className={`faq-item ${isOpen ? 'is-open' : ''}`} key={item.q}>
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                >
                  <span>{item.q}</span>
                  <SafeIcon
                    icon={FiChevronDown}
                    className={`faq-icon ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isOpen && <p className="faq-answer">{item.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default SeoContentSection;